
//for submit button
import { FormInstance } from "antd/es/form";
import {  Form } from "antd";
import Button from "@mui/material/Button";

import React from "react";

export const SubmitButton = ({ form, btnName}: { form: FormInstance,btnName:string }) => {
    const [submittable, setSubmittable] = React.useState(false);
  
    // Watch all values
    const values = Form.useWatch([], form); 
  
    React.useEffect(() => {
      form.validateFields({ validateOnly: true }).then(
        () => {
          setSubmittable(true);
        },
        () => {
          setSubmittable(false);
        }
      );
    }, [values]);
  
    return (
      <Button
        className="button-login"
        type="submit"
        disabled={!submittable}
        variant="text"
      >
        {btnName}
      </Button>
    );
  };